declare const ajax_object: { ajax_url: string } | undefined;

interface CachedCurrencyData {
    usd: string;
    eur: string;
    timestamp: number;
}

const CACHE_KEY = 'portalgd_currency_cache';
const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 hours

function getCachedCurrency(): CachedCurrencyData | null {
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (!cached) return null;

        const data: CachedCurrencyData = JSON.parse(cached);
        if (Date.now() - data.timestamp < CACHE_DURATION) {
            return data;
        }
        localStorage.removeItem(CACHE_KEY);
        return null;
    } catch {
        localStorage.removeItem(CACHE_KEY);
        return null;
    }
}

function setCachedCurrency(usd: string, eur: string): void {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ usd, eur, timestamp: Date.now() }));
    } catch {
        // ignore
    }
}

function setRatesOnElements(dollarEl: HTMLElement, euroEl: HTMLElement, usd: string, eur: string): void {
    dollarEl.textContent = usd.startsWith('R$') ? usd : `R$ ${usd}`;
    euroEl.textContent = eur.startsWith('R$') ? eur : `R$ ${eur}`;
}

async function loadCurrencyRates(): Promise<void> {
    const dollarElement = document.getElementById('dollar-rate');
    const euroElement = document.getElementById('euro-rate');

    if (!dollarElement || !euroElement) return;

    const cachedData = getCachedCurrency();
    if (cachedData) {
        setRatesOnElements(dollarElement, euroElement, cachedData.usd, cachedData.eur);
        return;
    }

    try {
        // Use WordPress AJAX proxy to avoid CORS issues
        const ajaxUrl = (typeof ajax_object !== 'undefined' && ajax_object.ajax_url)
            ? ajax_object.ajax_url
            : '/wp-admin/admin-ajax.php';

        const res = await fetch(`${ajaxUrl}?action=portalgd_currency`);
        const json = await res.json();

        if (json.success && json.data?.usd && json.data?.eur) {
            const usdRate = parseFloat(json.data.usd).toFixed(2);
            const eurRate = parseFloat(json.data.eur).toFixed(2);
            setRatesOnElements(dollarElement, euroElement, usdRate, eurRate);
            setCachedCurrency(usdRate, eurRate);
            return;
        }
    } catch {
        // ignore
    }

    dollarElement.textContent = 'Indisponível';
    euroElement.textContent = 'Indisponível';
}

document.addEventListener('DOMContentLoaded', loadCurrencyRates);

// Refresh every 30 min (only fetches if cache expired)
setInterval(loadCurrencyRates, 30 * 60 * 1000);
